module.exports = __webpack_public_path__ + "img/IMG_3670.4fa14446.jpg";